import { request as getPossibleBets } from './reducers/get-possible-bets';
import { request as placeBet } from './reducers/place-bet';
import { request as getReferredBetslip } from './reducers/get-referred-betslip';
import { request as acceptReferredBetslip } from './reducers/accept-referred-betslip';
import { request as offerReferredBetslip } from './reducers/offer-referred-betslip';
import { request as rejectReferredBetslip } from './reducers/reject-referred-betslip';
import { request as assignReferredBetslip } from './reducers/assign-referred-betslip';

export default {
    BETSLIP_GET_POSSIBLE_BETS_REQUEST: getPossibleBets,
    BETSLIP_PLACE_BET_REQUEST: placeBet,
    BETSLIP_GET_REFERRED_REQUEST: getReferredBetslip,
    BETSLIP_ACCEPT_REFERRED_REQUEST: acceptReferredBetslip,
    BETSLIP_OFFER_REFERRED_REQUEST: offerReferredBetslip,
    BETSLIP_REJECT_REFERRED_REQUEST: rejectReferredBetslip,
    BETSLIP_ASSIGN_REFERRED_REQUEST: assignReferredBetslip
};
